import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
class Navbar {
    constructor() {
        this.isClosed = false;
        this.body=document.querySelector("body");
        this.burgerMenu = document.querySelector("#hamburger")
        this.btnToggler=document.querySelector('.navbar-custom__toggler');
        this.navHeader = document.querySelector('.navbar-custom');
        this.scrollToTopBtn=document.querySelector(".button-gotop");
        this.lastScrollTop = 0;
        this.dropdowns = document.querySelectorAll(".dropdown")

        this.dropdownsTrigger = document.querySelectorAll(".dropdown-trigger")
    }
    // 2. events
    events() {
        this.hoverDropdown();
        this.hoverDropdownMobile()
        document.addEventListener("scroll", (event) => {
            let currentScrollPosition = window.scrollY;
            this.sticky(currentScrollPosition);
        });
        this.btnToggler.addEventListener('click', (event)=>{  
            event.preventDefault();
            this.burgerTime() 
        });
        if(this.scrollToTopBtn){
            this.scrollToTopBtn.addEventListener('click', (event)=>{  
                event.preventDefault();
                gsap.to(window, {duration: 0.1, scrollTo: 0,ease: "power2.inOut"});
            });
        }
    }
    // 3. methods (function, action...)
    sticky(currentScrollPosition) {
        if(currentScrollPosition<=0){
            this.navHeader.classList.remove('hide');
            this.navHeader.classList.remove('show');
        }
        else if(currentScrollPosition > this.lastScrollTop){
            this.navHeader.classList.add('hide');
            this.navHeader.classList.remove('show');
        } else {
            this.navHeader.classList.add('show');
            this.navHeader.classList.remove('hide');
        }
        this.lastScrollTop = currentScrollPosition;
        if(currentScrollPosition>750){
            if(this.scrollToTopBtn){
                this.scrollToTopBtn.classList.add('active')
            }
        }else{
            if(this.scrollToTopBtn){
                this.scrollToTopBtn.classList.remove('active')
            }
        }
    }
    burgerTime() {
        if (this.isClosed== true) {
            this.closeSideMenu();
        } else {
            this.openSideMenu()
        }
    }
    openSideMenu(){
        this.burgerMenu.classList.remove("closed");
        this.burgerMenu.classList.add("open");
        this.body.classList.add('no-scroll');
        this.isClosed = true;
    }
    closeSideMenu(){
        this.burgerMenu.classList.remove("open");
        this.burgerMenu.classList.add("closed");
        this.body.classList.remove('no-scroll');
        this.isClosed  = false;
    }
    scrollToSection(target){
        gsap.to(window, {duration: 0.1, scrollTo:target});
    }
    hoverDropdown(){
        for (const dropdown of this.dropdowns) {
            dropdown.addEventListener('mouseenter', function(event) {
                let target=event.target
                let dropdownToggle=target.querySelector('.dropdown-toggle')
                let dropdownMenu=target.querySelector('.dropdown-menu')
                target.classList.add('show');
                dropdownToggle.classList.add('show');
                dropdownMenu.classList.add('show');

                let el_overlay = document.createElement('span');
                el_overlay.className = 'screen-darken';
                document.body.appendChild(el_overlay)
            })
            dropdown.addEventListener('mouseleave', function(event) {
                let target=event.target
                let dropdownToggle=target.querySelector('.dropdown-toggle')
                let dropdownMenu=target.querySelector('.dropdown-menu')
                target.classList.remove('show');
                dropdownToggle.classList.remove('show');
                dropdownMenu.classList.remove('show');
                document.body.removeChild(document.querySelector('.screen-darken'));
            })
        }
    }

    hoverDropdownMobile(){
        for (const dropdown of this.dropdownsTrigger) {
            dropdown.addEventListener('click', function(event) {
                event.preventDefault();
            })
        }
    }
    getSectionId(){
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let value = params.section; 
        return value;
    }
    animate(){
        let navbarCustom=document.querySelector('.navbar-custom')
        let bannerLogo=document.querySelector('.banner-logo');
        let tlNavbar = gsap.timeline();
        tlNavbar.fromTo(navbarCustom, { opacity: 0, y:-200 }, { opacity: 1, y:0, duration: 1, ease: "expo.out" },"+=0.5")
        //tlNavbar.fromTo(bannerLogo, { opacity: 0 }, { opacity: 1, duration: 1,ease: "expo.out" })
    }
}
export default Navbar